import auth0 from 'auth0-js'
import EventEmitter from 'events'
import settings from '@/settings.js'
import store from '@/store'
import {setHeader} from '@/api'

export const webAuth = new auth0.WebAuth({
  domain: settings.AUTH_DOMAIN,
  redirectUri: settings.AUTH_REDIRECT_URI,
  clientID: settings.AUTH_CLIENT_ID,
  responseType: 'token',
  responseMode: 'fragment',
  usePostMessage: false,
  scope: 'openid'
})

class AuthService extends EventEmitter {
  // Starts the user login flow
  login (customState) {
    webAuth.authorize({
      appState: customState
    })
  }
  // Handles the callback request from Auth0
  handleAuthentication (localLogin = true) {
    return new Promise((resolve, reject) => {
      webAuth.parseHash((err, authResult) => {
        if (err) {
          reject(err)
        } else {
          localLogin && this.localLogin(authResult)
          resolve(authResult)
        }
      })
    })
  }
  setHttpToken (token) {
    setHeader('Authorization', token)
  }
  renewTokens () {
    return new Promise((resolve, reject) => {
      webAuth.renewAuth({ responseType: 'token', responseMode: 'fragment' }, (err, authResult) => {
        if (err) {
          reject(err)
        } else if (authResult && authResult.accessToken) {
          authResult.accessToken = `Bearer ${authResult.accessToken}`
          this.localLogin(authResult)
          resolve(authResult)
        }
        reject(Error('An unknown error occured during authentication'))
      })
    })
  }
  localLogin (authResult) {
    store.commit('setLoggedIn', true)
    store.commit('setToken', authResult.accessToken)
    this.setHttpToken(authResult.accessToken)
    store.dispatch('getAuthenticatedUser')
    this.emit('loginEvent', {
      loggedIn: true,
      ...authResult
    })
  }
  isAuthenticated () {
    console.log('IS AUTHENTICATED?', store.state.loggedIn)
    return store.state.loggedIn
  }
  logout () {
    store.commit('setLoggedIn', false)
    // TODO
    // perform redirect to logout page
    // perform ajax request to auth/logout
    // clear token in vuex state
  }
}

export const authService = new AuthService()
